import React from 'react';
import CommonModal from 'src/components/CommonModal';
import { iconMap } from 'src/constants/common';

interface IProps {
    handleClose: any;
    services: Array<{
        name: string;
        description: string;
    }>;
    title?: string;
}

const AdditionalServiceInfoModal = ({ handleClose, services, title }: IProps) => (
    <CommonModal title={title || 'Additional Services '} handleClose={() => handleClose(false)} size={'max-w-[810px]'} isOverflow={true} modalClassName="flex flex-col">
        <div className="px-4 py-4 overflow-y-auto custom-scrollbar-v2">
            <ul className="[&>*]:px-1.5 [&>*]:py-2 -mx-1.5 -my-2 flex flex-wrap">
                {services.map((service, index) => (
                    <li key={`service_${index}`} className="w-1/2">
                        <div className="rounded-lg border border-utilityGray200 bg-white shadow-xs px-3 py-4 space-y-2 h-full">
                            <div className="flex items-start gap-1.5">
                                {iconMap[service.name]?.icon && (
                                    <div className="h-5 flex items-center">
                                        {React.createElement(
                                            iconMap[service.name].icon,
                                            iconMap[service.name]?.className
                                                ? {
                                                      className: iconMap[service.name].className,
                                                  }
                                                : {}
                                        )}
                                    </div>
                                )}
                                <h6 className="text-grayLight900 text-sm font-semibold">{service.name}</h6>
                            </div>
                            <p className="text-grayLight600 text-xs font-normal">{service.description}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    </CommonModal>
);

export default AdditionalServiceInfoModal;
